import moment, { Moment, isMoment } from 'moment';

export class ProductActivationModel {
  private _productActivationStartDate : Moment = undefined;
  private _productActivationEndDate : Moment = undefined;

  public set productActivationStartDate(productActivationStartDate: string | Moment) {
    if (productActivationStartDate && !isMoment(productActivationStartDate)) {
      this._productActivationStartDate = moment(productActivationStartDate);
    }
  }

  public get productActivationStartDate(): Moment {
    return this._productActivationStartDate;
  }

  public get productActivationStartDateAsIsoString(): string {
    return this._productActivationStartDate.toISOString();
  }

  public set productActivationEndDate(productActivationEndDate: string | Moment) {
    if (productActivationEndDate && !isMoment(productActivationEndDate)) {
      this._productActivationEndDate = moment(productActivationEndDate);
    }
  }

  public get productActivationEndDate(): Moment {
    return this._productActivationEndDate;
  }

  public get productActivationEndDateAsIsoString(): string {
    return this._productActivationEndDate.toISOString();
  }

}
